// src/components/PerfilSelector.jsx
import React from 'react';

function PerfilSelector({ perfiles, seleccionar }) {
  return (
    <div style={{ marginTop: '1rem' }}>
      <h2 style={{ marginBottom: '1rem' }}>Selecciona un perfil</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        {perfiles.map((perfil) => (
          <div
            key={perfil.id}
            onClick={() => seleccionar(perfil)}
            style={{
              cursor: 'pointer',
              backgroundColor: '#222',
              borderRadius: '8px',
              padding: '10px 20px',
              color: 'white',
              border: '1px solid #444',
              minWidth: '100px',
              textAlign: 'center',
              transition: '0.2s',
            }}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#333')}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#222')}
          >
            <img
              src={`/avatars/${perfil.avatar || 'default.png'}`}
              alt="Avatar"
              style={{ width: 60, height: 60, borderRadius: '50%', marginBottom: 10 }}
            />
            <div>{perfil.nombre}</div>
            {perfil.pin && (
              <div style={{ fontSize: '0.8rem', color: '#bbb' }}>(con PIN)</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default PerfilSelector;
